export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7494.3309661c.jpg";